import { render, staticRenderFns } from "./Dwzxbgsq.vue?vue&type=template&id=f5938aae"
import script from "./Dwzxbgsq.vue?vue&type=script&lang=js"
export * from "./Dwzxbgsq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports